import { axiosInstance } from "./globals";
import * as userService from "./userService";
import _ from "lodash";
import { DataSourceRequest } from "@/model/DataSourceRequest";

export async function getWhiteboards(body: DataSourceRequest): Promise<any> {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Whiteboard/GetAll", body, { headers })).data;
}

export async function createWhiteboard(name: string): Promise<any> {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Whiteboard/Create", { name }, { headers })).data;
}

export async function updateWhiteboard(boardUid: string, name: string): Promise<any> {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Whiteboard/Update", { boardUid, name }, { headers })).data;
}

export async function deleteWhiteboard(boardUid: string): Promise<any> {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Whiteboard/Delete", { boardUid }, { headers })).data;
}

export async function updateWhiteboardShare(boardUid: string, linkAccessLevel: number): Promise<any> {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Whiteboard/Update", { boardUid, linkAccessLevel }, { headers })).data;
}

